// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const en = {
  "controls": {
    "boot": "Boot",
    "reset": "Reset",
    "copyScreen": "Copy Screen",
    "copyText": "Copy Text",
    "pasteText": "Paste Text",
    "saveState": "Save State",
    "restoreState": "Restore State",
    "toggleSound": "Toggle Sound",
    "retrySound": "Sound unavailable. Retry sound.",
    "settings": "Settings",
    "debugPanel": "Debug Panel",
    "infoPanel": "Info Panel",
    "reportIssue": "Report an Issue",
    "privacyPolicy": "Privacy Policy"
  },
  "config": {
    "speed": "Emulator Speed",
    "display": "Display Settings",
    "theme": "Theme",
    "openRetroControlPanel": "Control Panel",
    "resetSettings": "Reset All Settings",
    "resetSettingsText": "Are you sure you want to reset all settings? This will not erase your breakpoints or BASIC program.",
    "capsLock": "Caps Lock",
    "useOpenApple": "Use {{modKey}} key for Open Apple",
    "useShortcuts": "Use {{modKey}} key for Keyboard Shortcuts",
    "useArrowKeys": "Use Arrow Keys as Joystick",
    "scanlines": "CRT Scanlines",
    "ghosting": "Phosphor Ghosting",
    "crtDistortion": "CRT Distortion",
    "joystick": "Keyboard and Joystick Settings"
  },
  "machine": {
    "configuration": "Machine Configuration",
    "slotConfigurator": "Expansion Slots",
    "models": {
      "apple2p": "Apple II+",
      "apple2eu": "Apple IIe (unenhanced)",
      "apple2ee": "Apple IIe (enhanced)"
    },
    "ram": {
      "64kb_aux": "64 KB (AUX)",
      "512kb": "512 KB",
      "1024kb": "1024 KB",
      "4mb": "4 MB",
      "8mb": "8 MB"
    }
  },
  "speed": {
    "snail": "Snail Speed (0.1 MHz)",
    "slow": "Slow Speed (0.5 MHz)",
    "normal": "Normal Speed (1 MHz)",
    "two": "2 MHz",
    "three": "3 MHz",
    "fast": "Fast Speed (4 MHz)",
    "warp": "Ludicrous Speed"
  },
  "colors": {
    "color": "Color",
    "nofringe": "Color (no fringe)",
    "green": "Green",
    "amber": "Amber",
    "white": "Black and White",
    "inverse": "Black and White (inverse)"
  },
  "timetravel": {
    "configuration": "Time Travel Configuration",
    "snapshotOnKeyPress": "Take Snapshot On Keypress",
    "autoSnapshot": "Auto Snapshot",
    "auto_Off": "Off",
    "auto_100k": "Every 0.1s (100000 cycles)",
    "auto_1M": "Every 1s (1M cycles)"
  },
  "themes": {
    "classic": "Classic",
    "dark": "Dark",
    "minimal": "Minimal"
  },
  "debug": {
    "helpPanel": "Show help panel",
    "debugPanel": "Show debugging panel",
    "expectinPanel": "Show Apple exPectin panel",
    "helpTab": "Help",
    "debugTab": "Debugging",
    "basicTab": "Applesoft BASIC",
    "expectinTab": "Apple exPectin",
    "breakpoints": "Breakpoints",
    "memory": "Memory",
    "stack": "Stack",
    "state": "CPU State",
    "registers": "Registers",
    "flags": "Flags",
    "step": "Step",
    "stepOver": "Step Over",
    "stepInto": "Step Into",
    "stepOut": "Step Out",
    "resume": "Resume",
    "pause": "Pause",
    "loadSymbolTable": "Load Symbol Table",
    "agentTab": "Agent",
    "disassembly": "Disassembly",
    "breakOnce": "Break once then remove",
    "basicLineNumber": "BASIC Line Number:",
    "any": "Any",
    "stackDump": "Stack Dump",
    "timeTravelSnapshots": "Time Travel Snapshots",
    "heatMapTitle": "Heat Map",
    "memoryDumpTitle": "Memory Dump",
    "veraMonitor": "VERA Monitor",
    "pauseForDisassembly": "Pause to view disassembly",
    "cycles": "Cycles:",
    "resetCycleCountAndHeatMaps": "Reset cycle count and heat maps",
    "breakpointTitle": "Edit Breakpoint",
    "breakpoint": {
      "breakAt": "Break at:",
      "breakpoint": "Breakpoint",
      "watchpoint": "Watchpoint",
      "instruction": "Instruction",
      "address": "Address:",
      "hitCount": "Hit Count:",
      "expression": "Expression:",
      "memoryBank": "Memory Bank:",
      "opcode": "Opcode:",
      "addressingMode": "Mode:",
      "value": "Value:",
      "anyIllegal65C02": "Any illegal 65C02 opcode",
      "anyIllegal6502": "Any illegal 6502 opcode",
      "read": "Read",
      "write": "Write",
      "withHexValue": "With hex value:",
      "actions": "Actions:",
      "haltAfterActions": "Halt execution after actions",
      "actionAddress": "address",
      "actionToAddress": "to address",
      "actionToValue": "to value",
      "add": "Add new breakpoint",
      "removeAll": "Remove all breakpoints",
      "edit": "Edit breakpoint",
      "delete": "Delete breakpoint",
      "action": {
        "none": "(no action)",
        "set": "Set",
        "jump": "Jump to",
        "print": "Print to console",
        "snapshot": "Snapshot"
      },
      "register": {
        "address": "Address",
        "accumulator": "Accumulator",
        "x": "X Register",
        "y": "Y Register",
        "stack": "Stack Pointer",
        "status": "Processor Status",
        "programCounter": "Program Counter"
      },
      "mode": {
        "implied": "Implied",
        "immediate": "Immediate",
        "zeroPageRelative": "Zero page/Relative",
        "zeroPageX": "Zero page,X",
        "zeroPageY": "Zero page,Y",
        "absolute": "Absolute",
        "absoluteX": "Abs,X",
        "absoluteY": "Abs,Y",
        "indirectX": "Indirect,X",
        "indirectY": "Indirect,Y",
        "indirect": "Indirect"
      }
    },
    "heatMap": {
      "cpuProgramCounter": "6502 Program Counter",
      "count": "Count",
      "getMemoryCalls": "Get Memory Calls",
      "setMemoryCalls": "Set Memory Calls",
      "colorTable": "Color Table",
      "showMagnifier": "Show Magnifier",
      "jumpToProgramCounter": "Jump to current program counter",
      "jumpToMaximumValue": "Jump to maximum heatmap value"
    },
    "memoryDump": {
      "pickWatchpoint": "Pick Watchpoint",
      "saveMemory": "Save Memory",
      "highBitAscii": "High Bit ASCII",
      "searchHex": "Search Hex",
      "searchAscii": "Search ASCII",
      "noMatch": "no match",
      "matchCount": "{{match}} of {{total}}",
      "previousMatch": "Previous Match",
      "nextMatch": "Next Match",
      "range": {
        "current": "Current memory",
        "mainRam": "Main RAM",
        "auxiliaryRam": "Auxiliary RAM",
        "hgr1": "HGR page 1",
        "hgr2": "HGR page 2"
      }
    },
    "disassemblyPreviousLocation": "Previous Location",
    "disassemblyNextLocation": "Next Location",
    "memoryMap": {
      "title": "Memory Map",
      "read": "Read",
      "write": "Write",
      "zeroPage": "Zero Page",
      "stack": "Stack",
      "text": "Text",
      "hiresMode": "Hires",
      "hires": "HGR",
      "internalRom": "Internal ROM",
      "slotRom": "Slot ROM",
      "auxBank": "Aux Bank",
      "auxRead": "Aux Read",
      "auxWrite": "Aux Write",
      "store80": "80 Store",
      "mixed": "Mixed",
      "page2": "Page 2",
      "columns80": "80 Column",
      "doubleHires": "Dbl Hires",
      "video7Mono": "V7 Mono",
      "video7160": "V7 160x",
      "video7Mixed": "V7 Mixed",
      "internalCxxxRom": "Cxxx ROM",
      "internalC300Rom": "C300 ROM",
      "readRam": "Read RAM",
      "writeRam": "Write RAM",
      "bank2Switch": "Bank 2"
    }
  },
  "disassembly": {
    "memory": {
      "effectiveAddress": "Effective address: {{notation}}",
      "value": "Value: {{notation}}"
    },
    "keyboard": {
      "character": "Keyboard: \"{{character}}\"",
      "strobeClear": "Keyboard strobe: CLEAR (MSB = 0)",
      "strobeSet": "Keyboard strobe: SET (MSB = 1)",
      "anyKeyDownClear": "Any-key-down flag: CLEAR (MSB = 0)",
      "anyKeyDownSet": "Any-key-down flag: SET (MSB = 1)",
      "clearStrobe": "Clear keyboard strobe"
    },
    "cassette": {
      "toggleOutput": "Toggle cassette output",
      "sampleInput": "Sample cassette input",
      "sampleInputMirror": "Sample cassette-input mirror"
    },
    "speaker": {
      "toggleOutput": "Toggle speaker output"
    },
    "notice": {
      "emulatorIdentifier": "INFO: Apple2TS emulator identifier: $CD",
      "noWriteEffect": "INFO: This write has no effect on {{machine}}",
      "multipleTriggers": "WARNING: This instruction triggers the soft switch multiple times",
      "unknownWrite": "WARNING: This instruction writes an unknown value"
    },
    "rom": {
      "intCxOff": "Internal $Cx ROM: OFF (MSB = 0)",
      "intCxOn": "Internal $Cx ROM: ON (MSB = 1)",
      "slot3Off": "Slot 3 ROM: OFF (MSB = 0)",
      "slot3On": "Slot 3 ROM: ON (MSB = 1)",
      "internal": "Select internal ROM for {{range}}",
      "slot": "Select slot ROM for {{range}}"
    },
    "languageCard": {
      "bank1": "Language Card bank: 1 (MSB = 0)",
      "bank2": "Language Card bank: 2 (MSB = 1)",
      "readSourceRom": "Language Card read source: ROM (MSB = 0)",
      "readSourceRam": "Language Card read source: RAM (MSB = 1)",
      "selectBank": "Language Card: Select bank {{bank}}",
      "useRamForReads": "Language Card: Use RAM for reads",
      "useRomForReads": "Language Card: Use ROM for reads",
      "disableWrites": "Language Card: Disable writes",
      "resetPrewriteLatch": "Language Card: Reset prewrite latch",
      "armOrEnableWrites": "Language Card: Arm or enable writes"
    },
    "auxMemory": {
      "readStatusOff": "Auxiliary-memory reads: OFF (MSB = 0)",
      "readStatusOn": "Auxiliary-memory reads: ON (MSB = 1)",
      "readMain": "Select main memory for reads",
      "readAuxiliary": "Select auxiliary memory for reads",
      "writeStatusOff": "Auxiliary-memory writes: OFF (MSB = 0)",
      "writeStatusOn": "Auxiliary-memory writes: ON (MSB = 1)",
      "writeMain": "Select main memory for writes",
      "writeAuxiliary": "Select auxiliary memory for writes",
      "selectExpansionBank": "Select auxiliary expansion bank {{bank}} using {{addressing}} addressing",
      "altzpMain": "Select main zero page, stack, and bank-switched RAM",
      "altzpAuxiliary": "Select auxiliary zero page, stack, and bank-switched RAM",
      "altzpStatusMain": "Zero page, stack, and bank-switched RAM: MAIN (MSB = 0)",
      "altzpStatusAuxiliary": "Zero page, stack, and bank-switched RAM: AUXILIARY (MSB = 1)"
    },
    "displayMemory": {
      "80storeStatusOff": "PAGE2 selects display page 1 or 2 (MSB = 0)",
      "80storeStatusOn": "PAGE2 selects main or auxiliary display memory (MSB = 1)",
      "80storeOff": "Make PAGE2 select display page 1 or 2",
      "80storeOn": "Make PAGE2 select main or auxiliary display memory",
      "page2StatusClear": "Display-memory selection: PAGE 1 OR MAIN (MSB = 0)",
      "page2StatusSet": "Display-memory selection: PAGE 2 OR AUXILIARY (MSB = 1)",
      "selectPage1": "Select display page 1",
      "selectPage2": "Select display page 2",
      "page2Clear": "Select display page 1, or main display memory with 80STORE",
      "page2Set": "Select display page 2, or auxiliary display memory with 80STORE"
    },
    "display": {
      "altCharsetStatusOff": "Alternate character set: OFF (MSB = 0)",
      "altCharsetStatusOn": "Alternate character set: ON (MSB = 1)",
      "selectPrimaryCharset": "Select primary character set",
      "selectAlternateCharset": "Select alternate character set",
      "textModeStatusOff": "Text mode: OFF (MSB = 0)",
      "textModeStatusOn": "Text mode: ON (MSB = 1)",
      "selectGraphicsMode": "Select graphics mode",
      "selectTextMode": "Select text mode",
      "mixedDisplayStatusOff": "Mixed display: OFF (MSB = 0)",
      "mixedDisplayStatusOn": "Mixed display: ON (MSB = 1)",
      "selectFullScreenDisplay": "Select full-screen display",
      "selectMixedDisplay": "Select mixed graphics/text",
      "hiresModeStatusOff": "Hi-res mode: OFF (MSB = 0)",
      "hiresModeStatusOn": "Hi-res mode: ON (MSB = 1)",
      "selectLoresGraphics": "Select lo-res graphics",
      "selectHiresGraphics": "Select hi-res graphics",
      "disableDhires": "Disable DHIRES",
      "enableDhires": "Enable DHIRES",
      "verticalBlankActive": "Vertical blank: ACTIVE (MSB = 0)",
      "verticalBlankInactive": "Vertical blank: INACTIVE (MSB = 1)",
      "column80StatusOff": "80-column display: OFF (MSB = 0)",
      "column80StatusOn": "80-column display: ON (MSB = 1)",
      "setWidth": "Set display width to {{columns}} columns"
    },
    "annunciator": {
      "disable": "Disable annunciator {{number}}",
      "enable": "Enable annunciator {{number}}"
    },
    "transWarp": {
      "configuredMaximum": "TransWarp: Select configured maximum speed",
      "oneMhz": "TransWarp: Select 1 MHz",
      "disableUntilColdBoot": "TransWarp: Disable acceleration until cold boot"
    },
    "laser128ex": {
      "oneMhz": "Laser 128EX: Select 1 MHz maximum CPU speed",
      "twoPointThreeMhz": "Laser 128EX: Select 2.3 MHz maximum CPU speed",
      "threePointSixMhz": "Laser 128EX: Select 3.6 MHz maximum CPU speed",
      "disableDiskSlowdown": "Laser 128EX: Disable automatic 1 MHz slowdown for port 7 disk access (write-once bit 5)",
      "enableDiskSlowdown": "Laser 128EX: Enable automatic 1 MHz slowdown for port 7 disk access (write-once bit 5)"
    },
    "gameIO": {
      "pulseStrobe": "Pulse game-port strobe",
      "startPaddleTimers": "Start paddle timers",
      "buttonReleased": "Pushbutton {{number}}: RELEASED (MSB = 0)",
      "buttonPressed": "Pushbutton {{number}}: PRESSED (MSB = 1)",
      "paddleExpired": "Paddle {{number}} timer: EXPIRED (MSB = 0)",
      "paddleActive": "Paddle {{number}} timer: ACTIVE (MSB = 1)",
      "buttonMirrorReleased": "Pushbutton {{number}} mirror: RELEASED (MSB = 0)",
      "buttonMirrorPressed": "Pushbutton {{number}} mirror: PRESSED (MSB = 1)",
      "paddleMirrorExpired": "Paddle {{number}} timer mirror: EXPIRED (MSB = 0)",
      "paddleMirrorActive": "Paddle {{number}} timer mirror: ACTIVE (MSB = 1)"
    }
  },
  "tour": {
    "welcome": "Welcome to the Apple2TS emulator!",
    "clickNext": "To learn more, press the Next button.",
    "bootButton": "Click here to start the emulator.",
    "retroBootButton": "Select this option to start the emulator.",
    "resetButton": "Click here to Reset the Apple II and either reboot or enter BASIC.",
    "retroResetButton": "Select this option to reset the Apple II and either reboot or enter BASIC.",
    "diskImages": "Choose one of the installed disk images.",
    "floppyDisks": "Or click one of the floppy disk icons to load a disk image.",
    "retroFloppyDisks": "Or select a disk drive to load a disk image.",
    "saveRestore": "You can save and restore the complete state of the emulator using these buttons.",
    "retroSaveRestore": "You can save and restore the complete state of the emulator using these options.",
    "themeButton": "Click here to change the emulator UI theme.",
    "retroThemeButton": "Use the arrow keys to change the emulator UI theme.",
    "endTour": "You have reached the end of the tour.",
    "tourSelectorHint": "Click on the globe tour button to try one of the other tours, or press Finish to start using the emulator.",
    "retroTourSelectorHint": "Select a menu item to try one of the other tours, or press Finish to start using the emulator.",
    "settingsWelcome": "Apple2TS has a full set of controls for both the emulator and the Apple II.",
    "mainControls": "Here, you can boot and reset the Apple II, restore and save the state, copy the screen, or paste text into the emulator.",
    "snapshot": "At any point, you can take a snapshot of the current emulator state, then go back in time to an earlier state, or fast forward again. You can also save the emulator state with all of the current snapshots.",
    "pauseButton": "You can pause the emulator at any time, freezing the 6502 processor. This is useful for pausing the action in a game, or entering the debugger.",
    "debugButton": "Click on the bug to enter debug mode, where you can see the internal state of the 6502 processor. Click again to go back to normal mode.",
    "configButtons": "The bottom row of buttons controls the state of the Apple II, starting with the emulator speed, the screen color, and muting the sound.",
    "retroConfigButtons": "The Options menu controls the state of the Apple II, starting with the emulator speed, the screen color, and muting the sound.",
    "keyboardButtons": "If the caps lock key is turned on, then all typed characters are UPPERCASE.",
    "altArrowKeys": "The next key determines whether the {{modKey}} key is used for keyboard shortcuts or the Apple II Open Apple key. The final key determines whether the arrow keys can be used as the Apple II joystick.",
    "clearCookies": "Apple2TS automatically saves the current emulator settings as browser cookies. Press this button to reset these settings and delete the cookies.",
    "retroClearCookies": "Apple2TS automatically saves the current emulator settings as browser cookies. Select this option to reset these settings and delete the cookies.",
    "debugWelcome": "Apple2TS has a rich set of tools to analyze and debug 6502 assembly code.",
    "debugIcon": "Click on the Bug icon on the Info tabs to view the Debug panel.",
    "debugPause": "Press the Pause button to pause or resume execution of the emulator.",
    "debugControls": "Now that we have paused, we can step through the disassembled code using the Step Over, Into, and Out buttons. We can also quickly jump to the current address of the Program Counter (PC).",
    "debugDisassembly": "Here we see the disassembled code, with the hex addresses, the three-letter instruction, and any values or addresses. If you move your mouse over a green value, a tooltip will appear with the current value. Clicking on a blue address will scroll to that location. You can also click in the left gutter to add or remove breakpoints.",
    "debugInfo": "In the middle we have the Stack Dump and a Memory Map. The Memory Map updates in real time and shows you which memory banks are currently active.",
    "debugMemory": "The last section displays the Apple II memory. You can use the droplist to examine different portions of memory. If you switch to one of the HGR pages, you will get a magnified view of the hires screen, tied to the memory locations. You can also search for hex values or ASCII strings, and save the memory to a file.",
    "back": "Back",
    "close": "Close",
    "last": "Finish",
    "next": "Next",
    "nextLabelWithProgress": "Next (Step {step} of {steps})",
    "skip": "Close",
    "guidedTour": "Tours",
    "mainLabel": "Guided Tours: Main",
    "settingsLabel": "Guided Tours: Settings",
    "debugLabel": "Guided Tours: Debug"
  },
  "disk": {
    "drive1": "Drive 1",
    "drive2": "Drive 2",
    "hardDisk": "Hard Disk",
    "eject": "Eject Disk",
    "insert": "Insert Disk",
    "writeProtected": "Write Protected",
    "readWrite": "Read/Write",
    "empty": "Empty",
    "loading": "Loading...",
    "selectDisk": "Select Disk Image",
    "browse": "Browse",
    "internetArchive": "Internet Archive",
    "totalReplay": "Total Replay",
    "newReleases": "New Releases",
    "writeProtectDisk": "Write Protect Disk",
    "saveDiskToDevice": "Save Disk",
    "saveDiskTo": "Save Disk to",
    "saveDiskToMenu": "Save Disk to >",
    "addToFavorites": "Add to Favorites",
    "downloadDisk": "Download Disk",
    "downloadWoz": "Download WOZ Disk Image",
    "downloadAndEjectDisk": "Download and Eject Disk",
    "ejectDisk": "Eject Disk",
    "ejectAllDisks": "Eject All Disks",
    "saveDiskToOneDrive": "Save Disk to OneDrive",
    "saveDiskToGoogleDrive": "Save Disk to Google Drive",
    "loadDisk": "Load Disk...",
    "loadAdditionalDisks": "Load Additional Disk(s)...",
    "loadDiskFrom": "Load Disk from",
    "loadDiskFromMenu": "Load Disk from >",
    "loadDiskFromDevice": "Load Disk",
    "loadDiskFromDeviceReadOnly": "Load Disk from Device (Read-Only)",
    "loadDiskFromDeviceReadWrite": "Load Disk from Device (Read/Write)",
    "InternetArchive": "Internet Archive",
    "DemoZoo": "DemoZoo",
    "OneDrive": "OneDrive",
    "GoogleDrive": "Google Drive",
    "loadDiskFromInternetArchive": "Load Disk from Internet Archive",
    "loadDiskFromDemoZoo": "Load Disk from DemoZoo",
    "loadDiskFromOneDrive": "Load Disk from OneDrive",
    "loadDiskFromGoogleDrive": "Load Disk from Google Drive",
    "insertBlankDisk": "Insert Blank Disk",
    "syncEveryMinute": "Sync Every Minute",
    "syncEvery5Minutes": "Sync Every 5 Minutes",
    "pauseSyncing": "Pause Syncing",
    "syncNow": "Sync Now",
    "modified": "modified",
    "synced": "Synced",
    "diskImage": "Disk Image",
    "diskDrivesAndDevices": "disk drives and devices",
    "syncedAt": "Synced {{date}}",
    "clickToHide": "Click to hide",
    "clickToShow": "Click to show",
    "clickToLoadDiskImage": "Click to load disk image(s)",
    "downloadingDisk": "Downloading disk",
    "clickToRemoveFromDiskCollection": "Click to remove from disk collection",
    "clickToAddToDiskCollection": "Click to add to disk collection",
    "byCreator": "by {{creator}}",
    "clickToViewDetails": "Click to view details",
    "importImageIntoEmulator": "Import Disk Image into Emulator",
    "downloadDiskImage": "Download Disk Image",
    "standbyDisks": "Standby Disks (Click to change disk)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "TypeScript Apple IIe Emulator",
    "credit": "(c) {{year}} Chris Torrence and the Apple2TS contributors",
    "keyboardShortcuts": "Keyboard Shortcuts",
    "shortcutsUnavailable": "{{keyMod}} emulator shortcuts are unavailable while that key is assigned to Open Apple. Ctrl+0 through Ctrl+5 still select emulator speed.",
    "diskImages": "Disk images:",
    "diskContainers": "Compressed archives:",
    "multiDiskNotice": "Multi-disk swapping: Click a drive's multi-disk badge to open the quick-swap menu. Loading multi-disk archives (.zip, .7z, .gz) automatically mounts all disks into the swapper list.",
    "urlParameters": "Optional URL Parameters",
    "examples": "Examples",
    "mobileInstructions": "Mobile platforms:",
    "tapScreen": "Tap the screen to show the keyboard.",
    "arrowKeys": "Press the arrow keys, esc, or tab buttons to send those keys to the emulator.",
    "ctrlKey": "To send a control character, press the ctrl button once. Then tap the screen to show the keyboard and press the desired key. The ctrl button will automatically be released.",
    "ctrlLock": "To send multiple control characters, press the ctrl button twice to lock it on (indicated by a green dot). Then tap the screen to show the keyboard and press the desired keys. Press the ctrl button again to release it.",
    "appleKeys": "The open apple and closed apple keys behave the same as the ctrl key.",
    "controlPanelShortcut": "<Shift>+<Esc>: display the Apple2TS control panel",
    "openAppleKey": "Open Apple: press Left Alt/Option",
    "closedAppleKey": "Closed Apple: press Right Alt/Option",
    "joystickKeys": "Joystick Keys: Numpad 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "For the on-screen keyboard, to use CTRL or ESC keys,\ntouch key once to enable it then touch the desired letter key.",
    "urlParametersBody": "For optional URL parameters, append them to the URL after a question mark (?) and separate multiple parameters with an ampersand (&). Use # to specify the disk image. See the Link Builder dialog for examples.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay with debugging",
      "totalReplayChoplifter": "Total Replay, load Choplifter, embedded mode",
      "a2Desktop": "A2Desktop 2MG with fast speed and color",
      "embeddedBasic": "Embedded Applesoft BASIC Program",
      "binaryHexAddress": "Binary File with Hex Address"
    },
    "links": "Links",
    "resourceLinks": {
      "desktopApp": "Apple2TS Desktop App",
      "corsProxy": "CORS Proxy by Corsfix",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "Loading...",
    "fetchingCloudData": "Fetching cloud data",
    "error": "Error",
    "success": "Success",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "ok": "OK",
    "on": "on",
    "off": "off",
    "confirmTheme": "Reload the emulator and apply this theme now?",
    "confirmReset": "Reset all settings to default values?",
    "fileNotFound": "File not found",
    "invalidFile": "Invalid file format",
    "diskInserted": "Disk inserted",
    "diskEjected": "Disk ejected"
  },
  "keyboard": {
    "capsLock": "Caps Lock",
    "shift": "Shift",
    "ctrl": "Ctrl",
    "alt": "Alt",
    "openApple": "Open Apple",
    "closedApple": "Closed Apple",
    "escape": "Escape",
    "tab": "Tab",
    "enter": "Enter",
    "space": "Space",
    "backspace": "Backspace",
    "delete": "Delete",
    "return": "Return",
    "enableGamePatches": "Enable Game Patches"
  },
  "audio": {
    "speaker": "Speaker",
    "mockingboard": "Mockingboard",
    "midi": "MIDI",
    "configuration": "Audio Configuration",
    "volume": "Volume",
    "mute": "Mute",
    "waveform": "Waveform"
  },
  "print": {
    "printer": "Printer",
    "imageWriter": "ImageWriter",
    "imageWriterII": "ImageWriter II (Slot 1)",
    "print": "Print",
    "clear": "Clear",
    "save": "Save Output",
    "dumpScreen": "Dump Current Screen to Printer",
    "dumpScreenInverse": "Dump Current Screen (Inverse)",
    "sendToPrinter": "Send to Printer",
    "tearOff": "Tear off Page and Reset",
    "printedPage": "Printed page",
    "printerConfig": "Printer Configuration",
    "pageLength": "Page Length",
    "pageLengthLetter": "11 inch (Letter)",
    "pageLengthA4": "11.7 inch (A4)",
    "pageLengthTwelve": "12 inch"
  },
  "device": {
    "machineConfiguration": "Machine Configuration",
    "midiDeviceSelect": "MIDI Device Select",
    "serialPortSelect": "Serial Port Select",
    "mockingboardWaveform": "Mockingboard wave form"
  },
  "collection": {
    "showApple2TSCollection": "Show Apple2TS Collection",
    "showNewReleases": "Show new releases",
    "showFavorites": "Show favorites",
    "chooseDiskImage": "Choose disk image",
    "diskCollection": "Disk collection",
    "clickToShowDetails": "Click to show details for",
    "clickToLoadDisk": "Click to load disk",
    "diskIsNewRelease": "Disk is a new release",
    "diskIsApple2TSCollection": "Disk is part of the Apple2TS collection",
    "diskIsInternetArchive": "Disk is part of the Internet Archive",
    "diskIsDemoZoo": "Disk is part of DemoZoo",
    "clickToRemoveFromCollection": "Click to remove from disk collection",
    "clickToKeepInCollection": "Click to keep in disk collection",
    "clickToAddToCollection": "Click to add to disk collection",
    "diskIsSyncedVia": "Disk is synced via",
    "loadDiskIntoDrive": "Load Disk into Drive",
    "cloudAuthRequired": "auth required",
    "signIn": "Sign in",
    "exportDisksToHdv": "Export disks to HDV",
    "export": "Export",
    "clickToRemoveFromSelected": "Click to remove from selected disks",
    "clickToAddToSelected": "Click to add to selected disks",
    "reportExportIssue": "Report an export issue",
    "hdvExportTitleUnavailable": "Apple2TS could not include \"{{title}}\" in the HDV.",
    "continueHdvExportWithoutUnavailableTitles": "Continue creating the HDV and skip unavailable titles?",
    "exportUnavailable": "This disk cannot be exported",
    "exportTooLarge": "This disk is too large to export",
    "exportCopyProtected": "Copy protection prevents exporting this disk",
    "exportDosMasterIncompatible": "This disk is incompatible with DOS.MASTER",
    "exportStatusPending": "Checking whether this disk can be exported",
    "exportAvailable": "This disk can be exported",
    "creatingHdv": "Creating the HDV image",
    "hdvCreatedWithOmissions": "Apple2TS created the HDV with some titles omitted:\n\n{{details}}",
    "hdvCreationFailed": "Apple2TS could not create the HDV: {{message}}",
    "hdvDownloadFailed": "Apple2TS could not download the disk, so HDV creation was canceled.",
    "fetchingDisk": "Fetching disk {{current}} of {{total}}",
    "checkingDiskForExport": "Checking disk {{current}} of {{total}} for export",
    "selectAllDisks": "Select all disks",
    "clearDiskSelection": "Clear disk selection",
    "deleteAllBookmarks": "Delete all bookmarks",
    "restoreAllBookmarks": "Restore all bookmarks",
    "sort": {
      "nameAscending": "A-Z",
      "nameDescending": "Z-A",
      "newest": "New",
      "oldest": "Old"
    }
  },
  "debugControls": {
    "goBackInTime": "Go Back in Time",
    "takeSnapshot": "Take a Snapshot",
    "goForwardInTime": "Go Forward in Time",
    "saveStateWithSnapshots": "Save State with Snapshots",
    "resume": "Resume",
    "pause": "Pause",
    "trace": "Trace",
    "tracing": "Tracing",
    "downloadTraceLog": "Download Trace Log"
  },
  "fullscreen": {
    "fullScreen": "Full Screen"
  },
  "internetArchive": {
    "searchPlaceholder": "Type the name of a software title or click one of the categories above",
    "go": "GO"
  },
  "demoZoo": {
    "searchPlaceholder": "Search DemoZoo (title, author)...",
    "go": "GO",
    "all": "All",
    "demo": "Demo",
    "intro": "Intro",
    "cracktro": "Cracktro",
    "music": "Music",
    "previous": "Previous",
    "next": "Next",
    "firstPage": "First page",
    "lastPage": "Last page",
    "pageInput": "Page number",
    "pageOf": "Page {{page}} of {{pages}}",
    "noProductions": "No DemoZoo productions found.",
    "youtubeOnly": "This production only has a YouTube video link available:",
    "externalOnly": "This production only has an external DemoZoo link available:",
    "openInNewTab": "Open in New Tab",
    "snapshotBadge": "Snapshot at {{date}}",
    "snapshotCreated": "DemoZoo snapshot created: {{date}}"
  },
  "basic": {
    "newProgram": "New Program",
    "newProgramWarning": "This will clear the current program. You will lose any unsaved changes. Are you sure?",
    "runFromBeginning": "Run from Beginning",
    "break": "Break",
    "continueRunning": "Continue Running",
    "stepProgram": "Step Program",
    "resumeOutput": "Resume Output",
    "freezeOutput": "Freeze Output",
    "importProgram": "Import Program...",
    "exportProgram": "Export Program...",
    "renumberProgram": "Renumber Program",
    "rebuildProgram": "Rebuild Program from Memory",
    "displaySettings": "Display Settings",
    "autoLineNumbering": "Auto Line Numbering",
    "capitalizeKeywords": "Capitalize Keywords",
    "rebuildWarning": "This will replace the current program with a version rebuilt from the Apple II memory. You will lose any unsaved changes. Are you sure?",
    "variable": "Variable",
    "value": "Value"
  },
  "expectin": {
    "runScript": "Run Script",
    "stopScript": "Stop Script"
  },
  "saveDisassembly": {
    "title": "Save Disassembly",
    "startAddress": "Start address $",
    "endAddress": "End address $",
    "includeLabels": "Include symbol labels",
    "separatorLines": "Separator lines after JMP, RTS"
  },
  "gamepad": {
    "useArrowKeys": "Use Arrow Keys as Joystick",
    "siriusJoyport": "Sirius Joyport Mode",
    "reverseYAxis": "Reverse Y-Axis for Joystick",
    "touchJoystick": "Touch Screen Joystick",
    "tiltSensorJoystick": "Use Tilt Sensor as Joystick"
  },
  "traceSettings": {
    "title": "Trace Settings",
    "numLines": "Number of lines to keep:",
    "rangeWarning": "Must be between 100 and 100000",
    "collapseLoops": "Find repeating lines and collapse loops",
    "ignoreRegisters": "Ignore register values when finding repeating lines",
    "settings": "Settings",
    "unlimited": "Unlimited",
    "cyclesUnit": "cycles"
  },
  "keyboardControl": {
    "hideKeyboard": "Hide Keyboard",
    "showKeyboard": "Show Keyboard"
  },
  "linkBuilder": {
    "title": "Link Builder",
    "buttonTitle": "Link Builder",
    "userInterface": "User interface:",
    "machine": "Machine:",
    "colorMode": "Color mode:",
    "ramDiskSize": "Size of RAM disk (kb):",
    "emulatorSpeed": "Speed of emulator:",
    "uiTheme": "User Interface Theme:",
    "showDebugTab": "Show debug tab",
    "sound": "Sound",
    "startupOptionsTab": "Startup Options",
    "onStartup": "On startup:",
    "loadDiskImage": "Load Disk Image",
    "loadBasicProgram": "Load BASIC Program",
    "loadHexCode": "Load Hex Code",
    "diskImageToLoad": "Disk image to load on startup:",
    "customDiskUrl": "Custom disk image URL:",
    "textToType": "Text to type after loading disk:",
    "enterTextPlaceholder": "Enter Text or BASIC code here",
    "runBasicAfterLoading": "Run BASIC program after loading",
    "enterHexPlaceholder": "Enter hexadecimal code here, e.g. A9 01 8D 00 03",
    "hexLoadAddress": "Hex load address: $",
    "runHexAfterLoading": "Run Hex program after loading",
    "finalUrl": "Final URL:",
    "copyToClipboard": "Copy to Clipboard",
    "tryIt": "Try It",
    "reset": "Reset",
    "close": "Close",
    "customDiskUrlOption": "Custom URL",
    "gameModes": {
      "normal": "Normal",
      "game": "Game (no drives or tabs)",
      "embed": "Embed (hide all controls)"
    },
    "colorNames": {
      "color": "Color",
      "nofringe": "Color (no fringing)",
      "green": "Green Screen",
      "amber": "Amber Screen",
      "white": "White Screen",
      "inverse": "Inverse White"
    },
    "speedNames": {
      "snail": "Snail",
      "slow": "Slow",
      "normal": "1 MHz (default)",
      "two": "2 MHz",
      "three": "3 MHz",
      "four": "4 MHz",
      "warp": "Ludicrous"
    },
    "machines": {
      "enhanced": "Apple IIe enhanced",
      "unenhanced": "Apple IIe unenhanced",
      "apple2p": "Apple II+"
    },
    "themes": {
      "classic": "Classic",
      "dark": "Dark",
      "minimal": "Minimal"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192",
      "default": "64 (default)"
    },
    "slots": {
      "configure": "Configure slot cards",
      "slot": "Slot {{slot}}:",
      "cardNone": "None (empty)"
    },
    "additionalDiskDrives": "Additional Disk Drives",
    "slot6Drive1": "Slot 6 Drive 1 (Floppy 1)",
    "slot6Drive2": "Slot 6 Drive 2 (Floppy 2)",
    "slot7Drive1": "Slot 7 Drive 1 (Hard Drive 1)",
    "slot7Drive2": "Slot 7 Drive 2 (Hard Drive 2)",
    "slot2Drive1": "Slot 2 Drive 1 (VERA SD)",
    "slot4Drive1": "Slot 4 Drive 1 (VERA SD)",
    "addAdditionalDisk": "Add additional disk for swapping",
    "removeDisk": "Remove this disk",
    "addAnotherDisk": "Add another disk",
    "diskPlaceholder": "Disk {num} filename (e.g. sideB.woz|Scenario Disk)"
  },
  "agent": {
    "tabTitle": "Agent",
    "setupTitle": "🤖 AI Agent Setup",
    "setupInstruction": "Click the gear icon below to configure your AI assistant.",
    "welcomeTitle": "Welcome to the Apple II assistant! I can help you with:",
    "welcomeItem1": "Inspecting CPU registers and memory",
    "welcomeItem2": "Controlling execution (boot, reset, step, breakpoints)",
    "welcomeItem3": "Loading programs and managing disks",
    "welcomeItem4": "Debugging 6502 assembly code",
    "welcomeItem5": "Reading screen content and system state",
    "welcomePrompt": "Just ask me anything!",
    "userRole": "You",
    "assistantRole": "🤖 Assistant",
    "inputPlaceholder": "Ask me anything about the Apple II emulator... (Press Enter to send, Shift+Enter for new line)",
    "stop": "Stop",
    "send": "Send",
    "changeConfiguration": "Change configuration",
    "processing": "Processing...",
    "tokens": "• {{input}} in / {{output}} out",
    "configTitle": "Configure AI Agent",
    "provider": "Provider:",
    "model": "Model:",
    "apiKey": "API Key:",
    "ollamaUrl": "Ollama URL:",
    "save": "Save",
    "clear": "Clear",
    "storageWarning": "Your API key is stored locally in your browser and never sent to apple2ts.com. Get your {{provider}} API key at",
    "ollamaWarning": "Ollama runs locally on your machine. Make sure you have Ollama installed and running. Download from",
    "providerNotConfigured": "Provider not configured - click the gear icon to set up your AI agent",
    "providerConfigured": "Provider: {{provider}} ({{model}})",
    "invalidKeyFormat": "Invalid API key format for {{provider}}",
    "customModel": "Custom Model...",
    "customModelName": "Custom Model Name:"
  },
  "startup": {
    "welcome": "Welcome to Apple2TS",
    "subtitle": "TypeScript Apple II Emulator",
    "copyright": "(c) {{year}} C.Torrence + collaborators",
    "diskCollections": "Click on the Disk Collections icon\nto load a built-in disk or game.",
    "retroControlPanel": "Press SHIFT+ESC to display\nthe control panel."
  },
  "retroControl": {
    "ariaLabel": "Apple2TS control panel",
    "machine": "Machine",
    "fullscreen": "Fullscreen",
    "diskCollection": "Disks",
    "diskDrives": "Drives",
    "display": "Display",
    "monitorMode": "Monitor Mode",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Sound",
    "options": "Options",
    "skin": "Skin",
    "personalization": "Personalization",
    "text": "Text",
    "background": "Background",
    "border": "Border",
    "iigsColor": {
      "black": "Black",
      "red": "Red",
      "darkBlue": "Dark Blue",
      "purple": "Purple",
      "darkGreen": "Dark Green",
      "darkGray": "Dark Gray",
      "mediumBlue": "Medium Blue",
      "lightBlue": "Light Blue",
      "brown": "Brown",
      "orange": "Orange",
      "lightGray": "Light Gray",
      "pink": "Pink",
      "lightGreen": "Light Green",
      "yellow": "Yellow",
      "aquamarine": "Aquamarine",
      "white": "White"
    },
    "keyboard": "Keyboard",
    "input": "Input",
    "joystick": "Joystick",
    "slots": "Slots",
    "devices": "Devices",
    "printerPort": "Printer Port",
    "modemPort": "Modem Port",
    "quit": "Quit",
    "apple2tsCollection": "Apple2TS Collection",
    "newReleases": "New Releases",
    "favorites": "Favorites",
    "exportDisksToHdv": "Export Disks to HDV",
    "noDiskDrivesAvailable": "No disk drives available",
    "select": "Select",
    "open": "Open",
    "load": "Load",
    "go": "Go",
    "save": "Save",
    "clipboard": "Clipboard",
    "cancelEsc": "Cancel:Esc",
    "color": "Color",
    "colorNoFringe": "Color (no fringe)",
    "green": "Green",
    "amber": "Amber",
    "white": "White",
    "inverse": "Inverse",
    "snail": "Snail",
    "slow": "Slow",
    "normal": "Normal",
    "twoMhz": "2 MHz",
    "threeMhz": "3 MHz",
    "fast": "Fast",
    "warp": "Warp",
    "systemSpeed": "System Speed",
    "other": "Other",
    "timeMachine": "Snapshots",
    "ports": "Ports",
    "language": "Language",
    "port": "Port",
    "builtinImageWriter": "Builtin ImageWriter",
    "selectExternalPort": "Select External Port",
    "externalPort": "External Port",
    "retroTheme": "Retro",
    "lowercaseInput": "Lowercase input",
    "lowercase": "Lowercase",
    "openAppleKey": "Open Apple key",
    "sortOrder": "Sort",
    "slot": "Slot {{slot}}",
    "drive": "{{drive}}: {{disk}}",
    "configured": "{{count}} configured",
    "saveDisk": "Save Disk",
    "card": {
      "empty": "Empty",
      "ssc": "Super Serial Card",
      "softcard": "Z-80 SoftCard",
      "aux": "Auxiliary memory",
      "videoterm": "Videx VideoTerm",
      "mockingboard": "Mockingboard",
      "mouse": "Mouse card",
      "vera": "VERA graphics",
      "passport": "Passport MIDI",
      "disk2": "Disk II controller",
      "smartport": "SmartPort drive"
    },
    "fetchingDisk": "Fetching disk {{current}}/{{total}}",
    "downloadFailed": "Unable to download {{title}}",
    "exportFailed": "Export to HDV failed: {{message}}"
  },
  "binaryFile": {
    "title": "Load Binary File",
    "loadAtAddress": "Load into memory at address $",
    "runAfterLoading": "Run code after loading"
  }
}
